import { ReactNode } from 'react'
import { APIProvider } from '@vis.gl/react-google-maps'

interface MapProviderProps {
    children: ReactNode
}

// Single APIProvider for the whole app. Agent A should wrap <Root> with this
// at merge time so every map shares one Google Maps script load.
export const MapProvider = ({ children }: MapProviderProps) => (
    <APIProvider
        apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
        libraries={['marker', 'places', 'geometry']}
    >
        {children}
    </APIProvider>
)

export default MapProvider
